import { ADD_PROJECT, ADD_PROJECT_LINK, ADD_RELEASE_ID, ADD_SIMPLE_USER_LIST, CLEAR_RELEASE, CLEAR_PROJECT } from './projectTypes';

export const setProject = (project) => ({
    type: ADD_PROJECT,
    payload: project
});

export const setReleaseId = (releaseId) => ({
    type: ADD_RELEASE_ID,
    payload: releaseId
});

export const setProjectLink = (linkList) => ({
    type: ADD_PROJECT_LINK,
    payload: linkList
});

export const setSimpleUserList = (userList)=> ({
    type: ADD_SIMPLE_USER_LIST,
    payload: userList
});

export const clearRelease = () => ({
    type: CLEAR_RELEASE
});

export const clearProject = () => ({
    type: CLEAR_PROJECT,
});
